export const setting = state => k => {
  return state.settings[k]
}
export const langs = state => state.langs
export const lang = state => state.lang

export const online = state => {
  return state.online && state.settings.data
}

export const geoActive = state => state.geoActive
export const geoLocation = state => state.geoLocation
export const geoLoading = state => state.geoLoading
export const geoErr = state => state.geoErr
export const geoPos = state => {
  const geo = state.geoLocation
  return geo && geo.latitude && geo.longitude ? [geo.latitude, geo.longitude] : null
}
export const geoPrecision = state => {
  if (state.geoLocation && state.geoLocation.accuracy) {
    return state.geoLocation.accuracy
  } else {
    return null
  }
}

export const flyTo = state => state.flyTo

export const markers = state => {
  return Object.values(state.markers)
}
export const markersLoading = state => state.markersLoading
export const swiper = state => state.swiper
export const highlight = state => state.highlight
export const routeMarker = state => state.routeMarker
export const routePolyline = state => {
  return state.routePath && state.routePath.points ? state.routePath.points.coordinates.map(p => {
    return [p[1], p[0]]
  }) : []
}
export const routeInstructions = state => {
  return state.routePath && state.routePath.instructions ? state.routePath.instructions : []
}
export const routePath = state => state.routePath
